var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-carousel',{attrs:{"cycle":"","hide-delimiter-background":"","show-arrows-on-hover":""}},_vm._l((_vm.imgs),function(slide,i){return _c('v-carousel-item',{key:i},[_c('v-img',{attrs:{"src":_vm.getImgUrl(slide)}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }